<template>
  <Modal class-name = "card-modal" title = "Title" v-model = "showFormModal" :closable = "false">
    <div slot = "header">
      <h4>{{title}}</h4>
    </div>
    <Form ref = "eventAppSettings" :model = "newEventSet">
      <Divider orientation = "left" size = "small">Email Configuration</Divider>
      <table style = "width: 100%">
        <tr>
          <td valign = "middle" width = "20%">Sync Email</td>
          <td valign = "middle" width = "20%">
            <i-switch size = "large" v-model = "emailConfig.onSync">
              <span slot = "open">ON</span>
              <span slot = "close">OFF</span>
            </i-switch>
          </td>
          <td valign = "middle" width = "15%">Sync Label:</td>
          <td valign = "middle" width = "45%"><Input type = "text" v-model = "emailConfig.onSyncLabel"
                                                     placeholder = "Input sync label" /></td>
        </tr>
      </table>
      <br>
      <Divider orientation = "left" size = "small">Dashboard Settings</Divider>
      <table style = "width: 100%">
        <tr style = "height: 40px">
          <td valign = "middle" width = "20%">Display Name</td>
          <td valign = "middle" width = "25%">
            <i-switch size = "large" v-model = "dashboard.displayName">
              <span slot = "open">ON</span>
              <span slot = "close">OFF</span>
            </i-switch>
          </td>
          <td valign = "middle" width = "30%">Foreground Color</td>
          <td valign = "middle" width = "25%">
            <ColorPicker v-model = "dashboard.foregroundColor" recommend />
          </td>
        </tr>
        <tr style = "height: 40px">
          <td valign = "middle" width = "20%">Display Banner</td>
          <td valign = "middle" width = "25%">
            <i-switch size = "large" v-model = "dashboard.displayBanner">
              <span slot = "open">ON</span>
              <span slot = "close">OFF</span>
            </i-switch>
          </td>
          <td valign = "middle" width = "30%">Background Color</td>
          <td valign = "middle" width = "25%">
            <ColorPicker v-model = "dashboard.backgroundColor" recommend />
          </td>
        </tr>
      </table>
      <br>
      <Divider orientation = "left" size = "small">Company Logo</Divider>
      <Form enctype = "multipart/form-data">
        <table style = "width: 100%">
          <tr style = "height: 30px">
            <td valign = "middle" width = "10%">
              <label v-show = "isLogoImage">Image</label>
              <label v-show = "!isLogoImage">URL</label>
            </td>
            <td valign = "middle" width = "10%">
              <i-switch v-model = "isLogoImage" id = "logoSwitch" @on-change = "resetLogoPreview"></i-switch>
            </td>
            <td valign = "middle" width = "70%">
              <input accept = "image/*" name = "file" v-show = "isLogoImage" type = "file" id = "logoFile"
                     ref = "logoFile"
                     v-on:change = "logoChange($event.target.files)" />
              <Input v-show = "!isLogoImage"
                     @on-change = "displayLogo($event.target.value); fileImg = null;" />
            </td>
          </tr>
        </table>
        <i-col :xs = "24" :sm = "24" :md = "24" :lg = "24">
          <table class = "logoBox">
            <tr>
              <td align = "center" style = "max-width: 300px;max-height: 200px;">
                <div class = "logo_preview_cont"></div>
              </td>
            </tr>
          </table>
        </i-col>
      </Form>
    </Form>

    <div slot = "footer">
      <Button class="btn btn-outline-secondary btn-sm" @click="cancel">Cancel</Button>
      <Button class="btn btn-success btn-sm" @click="ok">OK</Button>
    </div>
  </Modal>
</template>

<script>
  import {
    getEmailConfig, addEmailConfig, updateEmailConfig,
    getDashboard, addDashboard, updateDashboard
  } from '../../services/Events.service'
  import {getCompanyById, updateCompany, uploadLogo} from '../../services/Companies.service'
  import moment from 'moment-timezone'

  export default {
    data() {
      return {
        eventId: null,
        companyId: null,
        newEventSet: {},
        showFormModal: false,
        title: '',
        emailAction: '',
        dashboardAction: '',
        isLogoImage: false,
        fileImg: new FormData(),
        newConfig: true,
        newDashboard: true,
        oldEmailConfig: {},
        emailConfig: {
          emailConfigId: null,
          eventId: null,
          companyId: null,
          dateModified: null,
          onSync: false,
          onSyncLabel: null
        },
        oldDashboard: {},
        dashboard: {
          dashBoardId: null,
          eventId: null,
          companyId: null,
          dateModified: null,
          backgroundColor: '#244697',
          foregroundColor: '#244697',
          displayName: true,
          displayBanner: true
        },
        company: {
          companyId: null,
          languageId: null,
          companyName: null,
          logoUrl: null,
          logoImage: null,
          address: null,
          city: null,
          country: null,
          phone: null,
          email: null
        },
        oldCompany: {}
      }
    },
    // props: ['emailConfig', 'dashboardSetting'],
    methods: {
      openConfigForm(title) {
        const self = this;
        self.showFormModal = true;
        self.title = title;
      },
      setValues() {
        const self = this;
        self.resetValues();
        var companyName = sessionStorage.getItem('companyName');
        var eventName = sessionStorage.getItem('eventName');
        if (companyName != null && companyName != '' && eventName != null && eventName != '') {
          self.companyId = JSON.parse(localStorage.getItem('companies')).filter(a => a.companyName === companyName)[0].companyId;
          self.eventId = JSON.parse(localStorage.getItem('events')).filter(a => a.eventName === eventName)[0].eventId;

          //Get EmailConfig
          getEmailConfig(self.eventId, self.companyId).then(response => {
            if (response.data != null && response.data != '') {
              self.emailConfig.emailConfigId = response.data.id;
              self.emailConfig.eventId = response.data.eventId;
              self.emailConfig.companyId = response.data.companyId;
              self.emailConfig.dateModified = response.data.dateModified;
              self.emailConfig.onSync = response.data.onSync;
              self.emailConfig.onSyncLabel = response.data.onSyncLabel;
              self.newConfig = false;
            }
            self.oldEmailConfig = Object.assign({}, self.emailConfig);
          });

          //Get DashboardSetting
          getDashboard(self.eventId, self.companyId).then(response => {
            if (response.data != null && response.data != '') {
              self.dashboard.dashBoardId = response.data.id;
              self.dashboard.eventId = response.data.eventId;
              self.dashboard.companyId = response.data.companyId;
              self.dashboard.dateModified = response.data.dateModified;
              self.dashboard.backgroundColor = response.data.backgroundColor;
              self.dashboard.foregroundColor = response.data.foregroundColor;
              self.dashboard.displayName = response.data.displayName;
              self.dashboard.displayBanner = response.data.displayBanner;
              self.newDashboard = false;
            }
            self.oldDashboard = Object.assign({}, self.dashboard);
          });

          //Get CompanybyId
          getCompanyById(self.companyId).then(response => {
            self.company.companyId = response.data.companyId;
            self.company.languageId = response.data.languageId;
            self.company.companyName = response.data.companyName;
            self.company.logoUrl = response.data.logoUrl;
            self.company.logoImage = response.data.logoImage;
            self.company.address = response.data.address;
            self.company.city = response.data.city;
            self.company.country = response.data.country;
            self.company.phone = response.data.phone;
            self.company.email = response.data.email;
            if (response.data.logoUrl) {
              self.displayLogo(response.data.logoUrl);
            } else {
              document.getElementsByClassName('logo_preview_cont')[0].innerHTML = "";
            }
            self.oldCompany = Object.assign({}, self.company);
          });
        }
        self.openConfigForm('Event App Settings');
      },
      ok() {
        const self = this;
        if (self.newConfig) {
          self.emailConfig.emailConfigId = 0;
          self.emailConfig.eventId = self.eventId;
          self.emailConfig.companyId = self.companyId;
          self.emailConfig.dateModified = moment(new Date());
          addEmailConfig(self.emailConfig).then(response => {
            console.log(response.data)
          }).catch(err => {
            self.$Message.error('Failed adding Email Configuration');
          });
        } else {
          if (JSON.stringify(self.emailConfig) !== JSON.stringify(self.oldEmailConfig)) {
            self.emailConfig.dateModified = moment(new Date());
            updateEmailConfig(self.eventId, self.companyId, self.emailConfig).then(response => {
              console.log(response.data)
            }).catch(err => {
              self.$Message.error('Failed updating Email Configuration');
            });
          }
        }
        if (self.newDashboard) {
          self.dashboard.dashBoardId = 0;
          self.dashboard.companyId = self.companyId;
          self.dashboard.eventId = self.eventId;
          self.dashboard.dateModified = moment(new Date());
          addDashboard(self.dashboard).then(response => {
            console.log(response.data)
          }).catch(err => {
            self.$Message.error('Failed adding Dashboard Setting');
          });
        } else {
          if (JSON.stringify(self.dashboard) !== JSON.stringify(self.oldDashboard)) {
            self.dashboard.dateModified = moment(new Date());
            updateDashboard(self.eventId, self.companyId, self.dashboard).then(response => {
              console.log(response.data)
            }).catch(err => {
              self.$Message.error('Failed updating Dashboard Setting');
            });
          }
        }
        if (JSON.stringify(self.company) !== JSON.stringify(self.oldCompany)) {
          if (self.fileImg !== null) {
            uploadLogo(self.companyId, self.fileImg).then(response => {
              if (response.data != "") {
                self.company.logoUrl = response.data;
              }
              updateCompany(self.companyId, self.company).catch(err => {
                self.$Message.error('Failed updating Company');
              });
            });
          }
        }
        self.$Message.info('You have successfully updated the Event App Settings!');
        self.showFormModal = false;
      },
      cancel() {
        this.showFormModal = false;
      },
      resetLogoPreview(val) {
        this.isLogoImage = val;
        if (this.isLogoImage) {
          document.getElementsByClassName('logo_preview_cont')[0].innerHTML = "";
        } else {
          if (this.company.logoUrl !== '' || this.company.logoUrl !== null) {
            this.displayLogo(this.company.logoUrl);
          }
        }
      },
      logoChange(fileList) {
        const self = this;
        if (fileList.length === 0) {
          self.company.logoUrl = self.oldLogoImage;
          self.fileImg = null;
          document.getElementsByClassName('logo_preview_cont')[0].innerHTML = "";
          return;
        }
        self.fileImg = new FormData();
        self.fileImg.append(fileList[0].name, fileList[0], 'CompanyLogo');
        var reader = new FileReader(),
          files = fileList[0];

        reader.onload = function (e) {
          self.displayLogo(e.target.result);
        }
        reader.readAsDataURL(files);
      },
      displayLogo(image) {
        var img = new Image();
        var container = document.getElementsByClassName('logo_preview_cont')[0];
        if (!container) return;
        container.innerHTML = "";
        img.id = 'logo_preview' + container.getElementsByTagName('img').length;
        img.src = image;
        img.style.height = '100%';
        img.style.width = '100%';
        container.appendChild(img);
      },
      resetValues() {
        const self = this;
        self.eventId = null;
        self.companyId = null;
        self.newEventSet = {};
        self.showFormModal = false;
        self.emailAction = '';
        self.dashboardAction = '';
        self.isLogoImage = false;
        self.fileImg = null;
        self.newConfig = true;
        self.newDashboard = true;
        self.emailConfig.emailConfigId = null;
        self.emailConfig.eventId = null;
        self.emailConfig.companyId = null;
        self.emailConfig.dateModified = null;
        self.emailConfig.onSync = false;
        self.emailConfig.onSyncLabel = null;
        self.dashboard.dashBoardId = null;
        self.dashboard.eventId = null;
        self.dashboard.companyId = null;
        self.dashboard.dateModified = null;
        self.dashboard.backgroundColor = '#244697';
        self.dashboard.foregroundColor = '#244697';
        self.dashboard.displayEventName = true;
        self.dashboard.displayEventBanner = true;
        self.oldCompany = null;
        self.oldEmailConfig = null;
        self.oldDashboard = null;
        self.company.companyId= null;
        self.company.languageId= null;
        self.company.companyName= null;
        self.company.logoUrl= null;
        self.company.logoImage= null;
        self.company.address= null;
        self.company.city= null;
        self.company.country= null;
        self.company.phone= null;
        self.company.email= null
      }
    },
    created() {
      const self = this;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/a_generalDashboard/EventAppSettings.vue